var version = '0.11.6';
export { version };
//# sourceMappingURL=version.js.map